import "./sprinkles.css.ts.vanilla.css-mistica.js";
import "./checkbox.css.ts.vanilla.css-mistica.js";
var v = {
    ios: "_1rz9b16 _1rz9b15 _1y2v1nfhl _1y2v1nfht _1y2v1nfhz _1y2v1nfi2 _1y2v1nfke _1y2v1nf3p",
    rest: "_1rz9b17 _1rz9b15 _1y2v1nfhl _1y2v1nfht _1y2v1nfhz _1y2v1nfi2 _1y2v1nfke _1y2v1nf3p",
    checked: "_1rz9b18 _1rz9b15 _1y2v1nfhl _1y2v1nfht _1y2v1nfhz _1y2v1nfi2 _1y2v1nfke _1y2v1nf3p"
}, r = "_1rz9b1a _1y2v1nfhm", f = "_1rz9b1b", y = "_1rz9b12 _1rz9b11 _1y2v1nfhn", b = "_1rz9b13 _1rz9b11 _1y2v1nfhn", h = "_1rz9b1c";
export { v as boxVariant, r as check, f as checkChecked, y as checkboxContainer, b as checkboxContainerDisabled, h as disabled };
